export default __webpack_public_path__ + "static/media/eb.bef25615.svg";